/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1AuthUpdatePayloadLocation
 */
export interface V1AuthUpdatePayloadLocation {
    /**
     *
     */
    lon?: number
    /**
     *
     */
    lat?: number
}

/**
 * Check if a given object implements the V1AuthUpdatePayloadLocation interface.
 */
export function instanceOfV1AuthUpdatePayloadLocation(
    value: object
): value is V1AuthUpdatePayloadLocation {
    return true
}

export function V1AuthUpdatePayloadLocationFromJSON(
    json: any
): V1AuthUpdatePayloadLocation {
    return V1AuthUpdatePayloadLocationFromJSONTyped(json, false)
}

export function V1AuthUpdatePayloadLocationFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1AuthUpdatePayloadLocation {
    if (json == null) {
        return json
    }
    return {
        lon: json['lon'] == null ? undefined : json['lon'],
        lat: json['lat'] == null ? undefined : json['lat']
    }
}

export function V1AuthUpdatePayloadLocationToJSON(
    json: any
): V1AuthUpdatePayloadLocation {
    return V1AuthUpdatePayloadLocationToJSONTyped(json, false)
}

export function V1AuthUpdatePayloadLocationToJSONTyped(
    value?: V1AuthUpdatePayloadLocation | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        lon: value['lon'],
        lat: value['lat']
    }
}
